const grillaSolicitudState = {
  prestacionesSolicitud: [],
  prestacionesSolicitudLength: 0,
  modalQuitarPrestacionSolicitud: false,
  modalEliminarBorrador: false,
  guidFilaQuitar: null,
  detalleBorrador: [],
  Solicitud: [],
  idSolicitud: null,
  modalSolicitudEnviada: false,
  cargandoBorrador: false,
  prestacionesToHomologador: [],
  IdSolicitudForHomologador: 0,
  IdSolicitudHomologador: null,
  creando: null,
  prestacionesHomologadas: [],
};

export default grillaSolicitudState;
